import { Timestamp } from '../../UI';
import { ReactComponent as FirstBagIcon } from '../../../assets/icons/xeu-blue-play.svg';
// Styles
import tableRowStyles from '../../../styles/table/TableRow.module.css';
import { BaggageArrivalFlight, BaggageTransferFlight } from '../../../types';

const FirstBagTableBlock = ({
	flight
}: {
	flight: BaggageArrivalFlight | BaggageTransferFlight;
}) => {
	return (
		<div
			className={`h-100  ${tableRowStyles.tableRowBlock} w-131px] justify-end items-center flex`}
		>
			<FirstBagIcon width={23} height={23} />
			<Timestamp
				classes={`time-tracker-timestamp ml-1 p-1 ${tableRowStyles.aeuTeuTableRowTimestamp}`}
				date={flight.actualFirstBag}
			/>
		</div>
	);
};

export default FirstBagTableBlock;
